import React, { useState } from 'react';
import { getContext } from 'common';
import CarouselAnimation from './CarouselAnimation';
import Styled from './styles';

export interface CarouselContentProps extends React.ComponentPropsWithRef<'div'> {
  /**  Content of the Carousel */
  children: React.ReactNode;
  /** Control animation config here. This uses react-spring transitions config. See https://react-spring.io for more information. */
  animationProps?: any;
  /** If true, disable all motion animation for this component. This property will override any global disableAnimation setting. */
  disableAnimation?: boolean;
  /** Shows the content of the active indicator */
  activeIndex?: number;
}

/** Should be nested in the `Carousel` component. All props will be provided to the root DOM element. */
const CarouselContent = React.forwardRef<HTMLElement, CarouselContentProps>((props: CarouselContentProps, ref) => getContext(({ RTL }) => {
  const {
    children,
    animationProps,
    disableAnimation,
    activeIndex,
    ...otherProps
  } = props;

  const [previousIndex, setPreviousIndex] = useState(-1);
  const [animateRight, setAnimateRight] = useState(RTL);

  if (activeIndex !== previousIndex) {
    if (activeIndex > previousIndex) {
      setAnimateRight(RTL);
      setPreviousIndex(activeIndex);
    }
    if (activeIndex < previousIndex) {
      setAnimateRight(!RTL);
      setPreviousIndex(activeIndex);
    }
  }

  return (
    <Styled.CarouselContent ref={ref} {...otherProps}>
      <CarouselAnimation disableAnimation={disableAnimation} animationProps={animationProps} activeIndex={activeIndex} animateRight={animateRight}>
        {children}
      </CarouselAnimation>
    </Styled.CarouselContent>
  );
}));

CarouselContent.defaultProps = {
  animationProps: undefined,
  disableAnimation: undefined,
  activeIndex: 0
};

CarouselContent.displayName = 'CarouselContent';

export default CarouselContent;